import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography, IconButton, Menu, MenuItem, ListItemText, FormControlLabel, Switch, TablePagination, Card, CardHeader, CardContent, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material"
import { Container } from "../components/Container"
import Layout from "../components/Layout"
import { FilterService } from "../components/FilterService"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { ServiceModal } from "../components/ServiceModal"
import { StatusBox } from "../components/StatusBox"
import { useEffect, useState, useCallback } from "react"
import { Settings } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { ServiceAPI } from "../api/ServiceAPI"
import { isMobile } from "react-device-detect"
import { toast } from "react-toastify"
import moment from "moment"
import { ClassificationAPI } from "../api/ClassificationAPI"
import { DetailedService } from "../components/DetailedService"
import { TwilioVideoPublisher } from "../components/twilio/TwilioVideoPublisher"
import { VideoAPI } from "../api/VideoAPI"

const STATUS_PROGRESS = 1;

export const Service = () => {

    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [rows, setRows] = useState([]);
    const [hideFinalized, setHideFinalized] = useState(true);
    const [detailedServiceOpen, setDetailedServiceOpen] = useState(false);
    const [classifications, setClassifications] = useState({});
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [total, setTotal] = useState(0);
    const [currentFilters, setCurrentFilters] = useState({});
    const [broadcastOpen, setBroadcastOpen] = useState(false);
    const [broadcastGuid, setBroadcastGuid] = useState(null);


    const loadData = useCallback(async (data = {}, currentPage = 0, currentRowsPerPage = rowsPerPage, shouldHideFinalized = hideFinalized) => {
        const params = {
            ...data,
            ...(shouldHideFinalized && { hide_finalized: true }),
            page: currentPage + 1,
            limit: currentRowsPerPage
        };

        const result = await ServiceAPI.getServices(params);
        if (result.success) {
            setRows(result.data.services || []);
            setCurrentFilters(data);

            if (result.data.total !== undefined) {
                setTotal(result.data.total);
            }

            const resultClassifications = await ClassificationAPI.getClassifications();
            if (resultClassifications.success) {
                setClassifications(resultClassifications.data || {});
            }

        } else {
            return toast.error(result.message || "Erro ao carregar dados");
        }
    }, [rowsPerPage, hideFinalized]);

    useEffect(() => {
        loadData({}, 0);
    }, [loadData]);

    const handleHideFinalizedChange = (event) => {
        const newValue = event.target.checked;
        setHideFinalized(newValue);
        setPage(0);
        loadData(currentFilters, 0, rowsPerPage, newValue);
    }

    const handleFilter = (data) => {
        setPage(0);
        loadData(data, 0);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        loadData(currentFilters, newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        loadData(currentFilters, 0, newRowsPerPage);
    }

    const handleOpenModal = () => {
        setModalOpen(true);
    }

    const handleCloseModal = () => {
        setModalOpen(false);
    }

    const handleServiceCreated = () => {
        loadData(currentFilters, page, rowsPerPage);
    }

    const handleMenuClick = (event, row) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };

    const handleViewDetails = () => {
        console.log(selectedRow);
        setDetailedServiceOpen(true);
    };

    const handleCloseDetailedService = () => {
        setDetailedServiceOpen(false);
    }

    const handleOpenBroadcast = () => {
        if (selectedRow && selectedRow.status_id === STATUS_PROGRESS) {
            setBroadcastGuid(selectedRow.guid);
            setBroadcastOpen(true);
        }
        handleMenuClose();
    };

    const handleCloseBroadcast = () => {
        setBroadcastOpen(false);
        setBroadcastGuid(null);
    };

    const handleCancelService = async () => {
        if (selectedRow) {
            try {
                const result = await ServiceAPI.cancelService(selectedRow.guid);
                if (result.success) {
                    toast.success(result.message || "Atendimento cancelado com sucesso");
                    loadData(currentFilters, page, rowsPerPage);
                } else {
                    toast.error(result.message || "Erro ao cancelar atendimento");
                }
            } catch (error) {
                toast.error("Erro ao cancelar atendimento");
            }
        }
        handleMenuClose();
    };

    const handleStartService = async () => {
        if (selectedRow) {
            try {
                const result = await ServiceAPI.startService(selectedRow.guid);
                if (result.success) {
                    toast.success(result.message || "Atendimento iniciado com sucesso");
                    loadData(currentFilters, page, rowsPerPage);
                }
            } catch (error) {
                toast.error("Erro ao iniciar atendimento");
            }
        }
        handleMenuClose();
    }
    const handleFinishService = async () => {
        if (selectedRow) {
            try {
                const result = await ServiceAPI.finishService(selectedRow.guid);
                if (result.success) {
                    toast.success(result.message || "Atendimento finalizado com sucesso");
                    loadData(currentFilters, page, rowsPerPage);
                } else {
                    toast.error(result.message || "Erro ao finalizar atendimento");
                }
            } catch (error) {
                toast.error("Erro ao finalizar atendimento");
            }
        }
        handleMenuClose();
    };

    const renderStatus = (row) => {
        return (
            <StatusBox
                status={row.status}
                customStatus={row.custom_status}
            />
        );
    };



    return (

        <Layout height="calc(100vh - 100px)">
            <Box marginBottom='10px'>
                <Typography variant="h4" component="h1" color="primary">
                    Atendimentos
                </Typography>
            </Box>

            <Box marginBottom="10px" display="flex" alignItems="center">
                <FormControlLabel
                    control={
                        <Switch
                            checked={hideFinalized}
                            onChange={handleHideFinalizedChange}
                            color="primary"
                        />
                    }
                    label="Esconder finalizados"
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '16px',
                            fontWeight: 500
                        }
                    }}
                />
            </Box>

            <Box marginBottom="10px" width="100%" display="flex" justifyContent="flex-end" className="gap-1">

                <Button
                    style={{ textTransform: "none" }}
                    color="primary"
                    variant="contained"
                    onClick={() => navigate("/status/config")}
                >
                    <Settings />
                </Button>
                <Button
                    style={{ textTransform: "none" }}
                    color="primary"
                    variant="contained"
                    onClick={handleOpenModal}
                >
                    <Typography>
                        Novo Atendimento
                    </Typography>
                </Button>
                <FilterService onFilter={handleFilter} classifications={classifications} />

            </Box>

            <Box display={{ xs: 'block', sm: 'none' }}>
                {rows.length === 0 ? (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="200px" color="#9CA3AF">
                        <Typography variant="body1" color="textSecondary">
                            Nenhum atendimento encontrado
                        </Typography>
                    </Box>
                ) : (
                    rows.map((row) => (
                        <Card key={row.id} sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}>
                            <CardHeader
                                title={
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        {row.pet?.name} - {row.company_service?.name}
                                    </Typography>
                                }
                                action={
                                    <IconButton
                                        onClick={(event) => handleMenuClick(event, row)}
                                        size="small"
                                    >
                                        <MoreHorizIcon />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" color="textSecondary">
                                        Identificação:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.id}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" color="textSecondary">
                                        Dono:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.pet?.owner?.name}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" color="textSecondary">
                                        Data de Início:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.created_at ? moment(row.created_at).format("DD/MM/YYYY") : '-'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" color="textSecondary" fontSize="13px">
                                        Última atualização:
                                    </Typography>
                                    <Typography variant="body2" fontSize="13px">
                                        {row.updated_at ? moment(row.updated_at).format("DD/MM/YYYY HH:mm") : '-'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography variant="body2" color="textSecondary">
                                        Status:
                                    </Typography>
                                    {renderStatus(row)}
                                </Box>
                            </CardContent>
                        </Card>
                    ))
                )}
            </Box>

            <Container isMobile={isMobile}>

                <Box >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Identificação</TableCell>
                                <TableCell>Pet</TableCell>
                                <TableCell>Dono</TableCell>
                                <TableCell>Serviço</TableCell>
                                <TableCell>Data de Início</TableCell>
                                <TableCell>Última atualização</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell align="right">Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.length > 0 ? (
                                rows.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.id}</TableCell>
                                        <TableCell>{row.pet?.name}</TableCell>
                                        <TableCell>{row.pet?.owner?.name}</TableCell>
                                        <TableCell>{row.company_service.deleted_at ? row.company_service.name + ' (Deletado)' : row.company_service?.name}</TableCell>
                                        <TableCell>{row.created_at ? moment(row.created_at).format("DD/MM/YYYY") : '-'}</TableCell>
                                        <TableCell>{row.updated_at ? moment(row.updated_at).format("DD/MM/YYYY HH:mm") : '-'}</TableCell>
                                        <TableCell>{renderStatus(row)}</TableCell>
                                        <TableCell align="right">
                                            <IconButton
                                                onClick={(event) => handleMenuClick(event, row)}
                                                size="small"
                                            >
                                                <MoreHorizIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        Nenhum atendimento encontrado
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <TablePagination
                        component="div"
                        count={total}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        labelRowsPerPage="Linhas por página:"
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`}
                    />
                </Box>
            </Container>

            <ServiceModal
                open={modalOpen}
                onClose={handleCloseModal}
                onSuccess={handleServiceCreated}
                currrentClassification={classifications}
            />

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 200,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    },
                }}
            >
                <MenuItem onClick={handleViewDetails}>
                    <ListItemText
                        primary="Ver Detalhes"
                        primaryTypographyProps={{
                            fontSize: '16px',
                        }}
                    />
                </MenuItem>
                <MenuItem onClick={handleStartService}>
                    <ListItemText
                        primary="Iniciar Atendimento"
                        primaryTypographyProps={{
                            fontSize: '16px',
                        }}
                    />
                </MenuItem>
                {selectedRow?.status_id === STATUS_PROGRESS && (
                    <MenuItem onClick={handleOpenBroadcast}>
                        <ListItemText
                            primary="Transmissão ao vivo"
                            primaryTypographyProps={{
                                fontSize: '16px',
                            }}
                        />
                    </MenuItem>
                )}
                <MenuItem onClick={handleCancelService}>
                    <ListItemText
                        primary="Cancelar Atendimento"
                        primaryTypographyProps={{
                            fontSize: '16px',
                        }}
                    />
                </MenuItem>
                <MenuItem onClick={handleFinishService}>
                    <ListItemText
                        primary="Finalizar Atendimento"
                        primaryTypographyProps={{
                            fontSize: '16px',
                        }}
                    />
                </MenuItem>
            </Menu>

            <DetailedService open={detailedServiceOpen} onClose={handleCloseDetailedService} service={selectedRow} />

            <Dialog open={broadcastOpen} onClose={handleCloseBroadcast} maxWidth="sm" fullWidth>
                <DialogTitle>Transmissão ao vivo</DialogTitle>
                <DialogContent>
                    {broadcastGuid && (
                        <TwilioVideoPublisher getToken={() => VideoAPI.getPublisherToken(broadcastGuid)} />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseBroadcast} color="inherit">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </Layout>

    )
}